// extracted by mini-css-extract-plugin
export default {"container":"qRN44JFj1IQOFwk_L41d","organisationInfo":"iSOY2P2wOPb4ZOjYhQxR","shortDescription":"UkCYf3ocrsvDycdHneYH"};